module.exports = __webpack_public_path__ + "img/Singapore.dd3ce243.png";